import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

type Props = { onSwitch: (page: "register" | "login") => void; showSuccess?: boolean };

const LoginPage: React.FC<Props> = ({ onSwitch, showSuccess }) => {
  const { login, resetPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await login(email, password);
      navigate("/inventory", { replace: true });
    } catch (err: any) {
      setError(err.message);
    }
  };

  const handleReset = async () => {
    if (!email) return setError("Enter your email to reset password.");
    try {
      await resetPassword(email);
      setError("Password reset email sent!");
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <form
      onSubmit={handleLogin}
      className="flex flex-col gap-4 bg-white rounded-xl shadow-md p-8 w-full max-w-md mx-auto"
    >
      {showSuccess && (
        <div className="fixed top-6 left-1/2 transform -translate-x-1/2 z-50">
          <div className="bg-green-500 text-white px-6 py-3 rounded-full shadow-lg animate-bounce">
            Registration successful! Please log in.
          </div>
        </div>
      )}
      <h2 className="text-xl font-semibold text-center">Login</h2>
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded relative text-center">
          {error}
        </div>
      )}
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
        className="input input-bordered w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        required
        className="input input-bordered w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-400"
      />
      <button
        type="submit"
        className="bg-indigo-500 text-white py-2 rounded hover:bg-indigo-600 transition"
      >
        Login
      </button>
      <div className="flex justify-between text-sm">
        <button
          type="button"
          className="text-indigo-500 hover:underline"
          onClick={() => onSwitch("register")}
        >
          Register
        </button>
        <button
          type="button"
          className="text-indigo-500 hover:underline"
          onClick={handleReset}
        >
          Forgot Password?
        </button>
      </div>
    </form>
  );
};

export default LoginPage;